import type { TBillingSubscriptionStage } from '@newo/api/gateway';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from '@/constants';

export type LearnMoreButton = {
    label: string;
    link: string;
    isExternal?: boolean;
};

export type StatusModeItem = {
    title: string;
    message: ReactNode;
    learnMoreButton: LearnMoreButton;
};

const HELP_ARTICLE =
    'https://help.newo.ai/en/articles/13786146-billing-process-guide-for-partners';

const learnMoreButton: LearnMoreButton = {
    label: 'Learn More',
    link: HELP_ARTICLE,
    isExternal: true
};

export const StatusModeContent: Partial<
    Record<TBillingSubscriptionStage | 'temporal', StatusModeItem>
> = {
    development: {
        title: 'Development mode:',
        message: (
            <>
                Your account is currently in the free development stage and has
                certain limitations.
                <Link
                    className="border-black-7 border-b no-underline	font-bold mx-1 max-w-fit text-black"
                    to={PATHS.profile.billing}
                >
                    Start 14-day free trial
                </Link>{' '}
                to remove the restrictions and make your agent public.
            </>
        ),
        learnMoreButton
    },
    trial: {
        title: 'Free trial:',
        message: (
            <>
                You are enjoying a 14-day free trial with full production
                access. Once this period ends, your paid subscription will begin
                automatically.
            </>
        ),
        learnMoreButton
    },
    temporal: {
        title: 'Temporary account:',
        message: (
            <>
                Your agent will be archived soon.
                <Link
                    className="border-black-7 border-b no-underline	font-bold mx-1 max-w-fit text-black"
                    to={PATHS.profile.billing}
                >
                    Activate free Development mode{' '}
                </Link>{' '}
                to keep it active.
            </>
        ),
        learnMoreButton
    }
};
